export function Field({ label, value, onChange, ...props }) {
  return (
    <label className="block">
      {label && <span className="text-sm font-medium text-emerald-900">{label}</span>}
      <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} {...props}
        className="mt-1 w-full rounded-lg border border-stone-300 px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-600 focus:border-emerald-600 outline-none" />
    </label>
  );
}

export function Area({ label, value, onChange, rows = 4, ...props }) {
  return (
    <label className="block">
      {label && <span className="text-sm font-medium text-emerald-900">{label}</span>}
      <textarea value={value ?? ""} onChange={(e) => onChange(e.target.value)} rows={rows} {...props}
        className="mt-1 w-full rounded-lg border border-stone-300 px-3 py-2 text-sm focus:ring-2 focus:ring-emerald-600 outline-none" />
    </label>
  );
}

export function Select({ label, value, onChange, options }) {
  return (
    <label className="block">
      {label && <span className="text-sm font-medium text-emerald-900">{label}</span>}
      <select value={value} onChange={(e) => onChange(e.target.value)}
        className="mt-1 w-full rounded-lg border border-stone-300 px-3 py-2 text-sm bg-white focus:ring-2 focus:ring-emerald-600 outline-none">
        {options.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </label>
  );
}

export function StatusBadge({ status }) {
  const map = { published: "bg-emerald-100 text-emerald-700", draft: "bg-amber-100 text-amber-700",
    new: "bg-blue-100 text-blue-700", contacted: "bg-purple-100 text-purple-700",
    scheduled: "bg-emerald-100 text-emerald-700", archived: "bg-stone-200 text-stone-600" };
  return <span className={`text-xs font-semibold px-2.5 py-1 rounded-full capitalize ${map[status] || "bg-stone-100 text-stone-600"}`}>{status}</span>;
}

export function Btn({ children, variant = "primary", ...props }) {
  const v = {
    primary: "bg-emerald-800 text-amber-50 hover:bg-emerald-900",
    outline: "border border-stone-300 text-emerald-900 hover:bg-stone-100",
    danger: "bg-red-600 text-white hover:bg-red-700",
    ghost: "text-emerald-800 hover:bg-emerald-50",
  }[variant];
  return <button {...props} className={`inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors disabled:opacity-60 ${v} ${props.className || ""}`}>{children}</button>;
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
      <div><h1 className="text-2xl font-serif text-emerald-950">{title}</h1>{subtitle && <p className="text-sm text-stone-500 mt-1">{subtitle}</p>}</div>
      <div className="flex gap-2">{children}</div>
    </div>
  );
}
